import { PlatformLogo } from '@/components/atoms/PlatformLogo';
import type { Translation } from '@/lib/i18n';
import type { PlatformResponse } from '@/lib/platformTypes';
import { LoaderCircle } from 'lucide-react';
import type { CSSProperties } from 'react';

type Props = { translation: Translation; platform: PlatformResponse };

export function TransitionPage({ translation, platform }: Props) {
	return (
		<div
			className="absolute inset-0 z-10 bg-[#f8faf9]"
			data-testid="transition-overlay"
			style={{ '--brand-color': platform.branding.primary_color } as CSSProperties}
		>
			<main
				className="flex h-full flex-col items-center justify-center px-4 py-12 text-center"
				aria-live="polite"
			>
				<div className="relative grid size-48 place-items-center rounded-full border-2 border-primary/20 sm:size-52">
					<PlatformLogo
						name={platform.branding.name}
						logo={platform.branding.logo}
						color={platform.branding.primary_color}
						size="xl"
					/>
				</div>

				<p className="mt-10 mb-0 text-sm font-extrabold tracking-[.24em] text-primary uppercase sm:text-base">
					{translation.connecting}
				</p>

				<h1 className="mb-0 mt-8 text-[clamp(2.35rem,4vw,3.4rem)] font-[750] leading-none tracking-[-.045em] text-[#16221f]">
					{platform.branding.name}
				</h1>

				<p className="mt-5 mb-0 text-xl leading-relaxed text-[#99a3a0] sm:text-2xl">{platform.host}</p>

				<LoaderCircle
					className="mt-12 size-14 animate-spin text-primary motion-reduce:animate-none"
					aria-label={translation.loading}
				/>
			</main>
		</div>
	);
}
